import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
};

export const fetchBanner = createAsyncThunk(
    'masters/fetchBanner',
    async (query) => {
        try {
            const response = await myAxios.get(`/masters/banners`);
            return { success: true, message: "Banners fetched successfully!", data: response?.data?.banners };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);
export const createBanner = createAsyncThunk(
    'masters/createBanner',
    async (data) => {
        try {
            const response = await myAxios.post(`/masters/banners`, data.formData);
            return { success: true, message: "Banner added successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


export const updateBanner = createAsyncThunk(
    'masters/updateBanner',
    async (data) => {
        try {
            const response = await myAxios.patch(`/masters/banners/${data?.query?.bannerId}`, data?.formData);
            return { success: true, message: "Banner updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const deleteBanner = createAsyncThunk(
    'masters/deleteBanner',
    async (query) => {
        try {
            const response = await myAxios.delete(`/masters/banners/${query.bannerId}`);
            return { success: true, message: "Banner deleted successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);



const bannerSlice = createSlice({
    name: 'banner',
    initialState,
    reducers: {
        clearBannerData: state => {
            state.data = [];
        },
        setBannerData: (state, action) => {
            state.data = action.payload;
        },
       
    },
});

export const bannerReducer = bannerSlice.reducer;
export const { clearBannerData, setBannerData } = bannerSlice.actions;

export const selectBannerData = (state) => state.banner.data;
